var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.75 3h-7.5v12h10.5V6h-3zm-9-.756c0-.411.336-.744.749-.744H12.5l3.75 3.75v10.494a.75.75 0 0 1-.745.756H3.495a.75.75 0 0 1-.745-.744zM10.25 9v3h-1.5V9H6.5l3-3 3 3z"
  })));
};
export default SvgUpload;